// extracted by mini-css-extract-plugin
export default {"resetButton":"AMjaR5J","body":"Vm2dNzK","isDragging":"siD47u6","closeBtn":"e42kg9J"};